import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ActionSheetController, MenuController } from '@ionic/angular';

import { GlobalConstants, WebAPIConstants } from 'src/app/services/globalConstants/global-constants.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VisitaService } from 'src/app/services/visita/visita.service';
import { SliderService } from 'src/app/services/slider/slider.service';

import { ISlide } from 'src/app/interfaces/ISlide';

import emailjs, { EmailJSResponseStatus } from 'emailjs-com';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.page.html',
  styleUrls: ['./inicio.page.scss'],
})
export class InicioPage implements OnInit {

  //#region Propiedades

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;

  public _allSlides: Array<ISlide>;

  public _enviando: boolean = false;

  public _contactoNombre: string = '';
  public _contactoEmail: string = '';
  public _contactoMsg: string = '';

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _menuCtrl: MenuController,
              private _actionSheetCtrl: ActionSheetController,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              private _sliderSrv: SliderService) {

    console.log('InicioPage >> constructor');

  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    console.log('InicioPage >> ngOnInit');
    this._menuCtrl.enable(false);
  }

  public async ionViewDidEnter() {
    console.log('InicioPage >> ionViewDidEnter');

    // Nota: Se borra el token local, para prueba
    await this._usuarioSrv.delPublicToken();

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('Inicio', null, null,
      null, null, null, null,
      null, null,
      this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
    });

    // Recupera slides
    this._sliderSrv.getAllSlides().subscribe(() => {
      this._allSlides = this._sliderSrv.AllSlides;

      // construye url de las imagenes
      this._allSlides.forEach(item => {
        item.UrlImagen = WebAPIConstants.URLSliderImagenes + item.UrlImagen;
      });
    });

  }

  //#endregion Eventos NG

  //#region Eventos Botones

  public btnSendEmail(e: Event) {

    this._enviando = true;

    e.preventDefault();
    emailjs.sendForm('service_o74k064', 'template_2yg6bz3', e.target as HTMLFormElement, 'user_ucBljD7dWIjyWYNEjxtQ6')
      .then((result: EmailJSResponseStatus) => {
        console.log(result.text);

        this._contactoNombre = '';
        this._contactoEmail = '';
        this._contactoMsg = '';

        this._actionSheetCtrl.create({
          header: 'Gracias por contactarnos, nuestro personal le dará seguimiento a tu mensaje. Saludos!',
          animated: true,
          cssClass: 'actionSheetCtrl',
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              cssClass: 'secondary',
              }
            ]
        }).then((alert) => {
          this._enviando = false;
          alert.present();
        });
      }, (error) => {
        console.log(error.text);

        this._actionSheetCtrl.create({
          header: 'Existió un error al enviar su mensaje. Por favor intente de nuevo.',
          animated: true,
          cssClass: 'actionSheetCtrl',
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              cssClass: 'secondary',
              }
            ]
        }).then((alert) => {
          this._enviando = false;
          alert.present();
        });
      });
  }

  public btnFacebookClick() {
    window.open(GlobalConstants.URL_FACEBOOK, '_new');
  }

  public btnInstagramClick() {
    window.open(GlobalConstants.URL_INSTAGRAM, '_new');
  }

  public btnEmailClick() {
    window.open('mailto:contacto@pastelerialasalle.com.mx', '_new');
  }

  //#endregion

}
